import slugify from "slugify"

const removeTrailingCapitalLetters = value =>
  value.replace(/([a-z0-9])[A-Z]+$/, "$1")

export const normalizeUrlSlug = value => {
  const input = String(value || "").trim()
  if (!input) return ""

  return slugify(removeTrailingCapitalLetters(input), {
    lower: true,
    strict: true,
    trim: true,
  })
}

